import dayjs from "dayjs";

export function time(value: string | null | undefined) {
  return value ? dayjs(value).format("YYYY-MM-DD HH:mm:ss") : "—";
}

export function money(value: string | number) {
  const number = Number(value);
  if (!Number.isFinite(number)) return `$${value}`;
  const digits = number >= 1000 ? 2 : number >= 1 ? 4 : number >= 0.01 ? 6 : 8;
  return `$${number.toLocaleString("en-US", { maximumFractionDigits: digits })}`;
}

export function compactMoney(value: string | number) {
  return `$${Intl.NumberFormat("zh-CN", { notation: "compact", maximumFractionDigits: 2 }).format(Number(value))}`;
}
